import { render, staticRenderFns } from "./PaymentDetai.vue?vue&type=template&id=6e506fd8&scoped=true"
import script from "./PaymentDetai.vue?vue&type=script&lang=js"
export * from "./PaymentDetai.vue?vue&type=script&lang=js"
import style0 from "./PaymentDetai.vue?vue&type=style&index=0&id=6e506fd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e506fd8",
  null
  
)

export default component.exports